import HTMLReactParser from "html-react-parser/lib/index";
import React, { useEffect, useRef, useState } from "react";

function MultiCheckboxPopupList({
  label,
  options,
  selectedOptions,
  onSelect,
  setSelectedOptions,
  register,
  fieldName,
  values,
  checked,
  setisFilterAppliedforDealandStatus,
  isFilterAppliedforDealandStatus,
  setisFilterAppliedforStatus,
  isFilterAppliedforStatus,
  statusFilter,
}) {
  const [isOpen, setIsOpen] = useState(false);
  // const [isFilterAppliedforDealandStatus, setisFilterAppliedforDealandStatus] = useState(false);


  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  // const handleCheckboxChange = (option) => {
  //   debugger;
  //   const newSelectedOptions = selectedOptions?.map(x=>x.label).includes(option)
  //     ? selectedOptions.filter((item) => item !== option)
  //     : [...selectedOptions, option];

  //   onSelect(newSelectedOptions);
  //   if (setisFilterAppliedforDealandStatus)
  //     newSelectedOptions?.length === 0 ? setisFilterAppliedforDealandStatus(false) : setisFilterAppliedforDealandStatus(true);
  //   if (setisFilterAppliedforStatus)
  //     newSelectedOptions?.length === 0 ? setisFilterAppliedforStatus(false) : setisFilterAppliedforStatus(true);
  // };


const handleCheckboxChange = (optionValue) => {
  let newSelectedOptions;

  if (selectedOptions.includes(optionValue)) {
    // Remove the unchecked option
    newSelectedOptions = selectedOptions.filter(item => item !== optionValue);
  } else {
    // Add the checked option
    newSelectedOptions = [...selectedOptions, optionValue];
  }

  onSelect(newSelectedOptions);

  const isApplied = newSelectedOptions.length > 0;
  if (setisFilterAppliedforDealandStatus) setisFilterAppliedforDealandStatus(isApplied);
  if (setisFilterAppliedforStatus) setisFilterAppliedforStatus(isApplied);
};


  // const handleSelectAll = () => {
  //   if (selectedOptions?.length === options?.length) {
  //     setSelectedOptions([]);
  //     if (setisFilterAppliedforDealandStatus)
  //      setisFilterAppliedforDealandStatus(false);

  //      if (setisFilterAppliedforStatus)
  //     setisFilterAppliedforStatus(false);
  //   }
  //   else {
  //     setSelectedOptions(options);
  //      if (setisFilterAppliedforDealandStatus)
  //      setisFilterAppliedforDealandStatus(true);

  //      if (setisFilterAppliedforStatus)
  //     setisFilterAppliedforStatus(true);
  //   }
  // };

  
// const handleSelectAll = () => {
//   if (selectedOptions?.length === options?.length) {
//     onSelect([]);
//     if (setisFilterAppliedforDealandStatus) setisFilterAppliedforDealandStatus(false);
//     if (setisFilterAppliedforStatus) setisFilterAppliedforStatus(false);
//   } else {
//     onSelect(options.map(opt => opt.value)); // or opt itself if needed
//     if (setisFilterAppliedforDealandStatus) setisFilterAppliedforDealandStatus(true);
//     if (setisFilterAppliedforStatus) setisFilterAppliedforStatus(true);
//   }
// };


const handleSelectAll = () => {
  const isAllSelected = selectedOptions.length === options.length;

  const newSelectedOptions = isAllSelected ? [] : options.map(opt => opt.value);
  onSelect(newSelectedOptions);

  const isApplied = newSelectedOptions.length > 0;
  if (setisFilterAppliedforDealandStatus) setisFilterAppliedforDealandStatus(isApplied);
  if (setisFilterAppliedforStatus) setisFilterAppliedforStatus(isApplied);
};



  const selectRef = useRef(null);


  const handleClickOutside = (event) => {
    if (selectRef.current && !selectRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (statusFilter) {
      handleCheckboxChange(options?.filter(x => x?.label.toLowerCase() === statusFilter?.toLowerCase())[0]?.value);
    }
  }, [statusFilter])

  return (
    <div ref={selectRef} className={`select-container ${isFilterAppliedforDealandStatus || isFilterAppliedforStatus  ? 'filter-applied' : ''}`}>
      <button
        className="buttonborder w-max  h-[40px] pr-2 pl-2"
        onClick={handleToggle}
      >
        <span className="flex">{label}
          <svg className="mt-2 ml-4" width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L7 7L13 1" stroke="#231F20" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </span>

      </button>
      {isOpen && (
        <div className="popup border w-max absolute bg-white pl-4 pr-4 pt-4 pb-4">
          <div className='flex'>
            <input
              type="checkbox"
              checked={selectedOptions?.length === options?.length}
              onChange={handleSelectAll}
            />

            <label className='font-normal ml-2'> All</label>
          </div>
          {options.map((option) => (
            <div className='flex'>
              <li style={{ listStyle: 'none' }}>
                <div className='flex'>
                  <input
                    type="checkbox"
                    checked={selectedOptions.includes(option.value)}
                    onChange={() => handleCheckboxChange(option.value)}
                    name={fieldName}
                  // {...register(fieldName)}
                  // checked={checked}
                  />
                  {option?.imageurl && (
                    <span className="ml-2">
                      {HTMLReactParser(option?.imageurl)}
                    </span>
                  )}
                  <p className='font-normal ml-2'>
                    {"  "}
                    {option.label}
                  </p>
                </div>
              </li>
            </div>
          ))}
        </div>


      )}
    </div>

  );
}

export default MultiCheckboxPopupList;
